module.exports = __webpack_public_path__ + "img/31 de octubre_Concierto en Clave de Halloween.d335cede.png";